import { getMemberData, bindFacebook, bindGoogle } from 'actions/member';

export default store => ({
	path: 'member',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container').default;
					cb(null, component);
				},
				'Member',
			),
		onEnter: ({ location: { query: { token = '', service = '' } } }, replace) => {
			const { auth: { token: { accessToken } } } = store.getState();
			if (accessToken === '') {
				replace({ pathname: '/login' });
				return;
			}
			if (service === 'facebook') {
				store.dispatch(bindFacebook(token));
			} else if (service === 'google') {
				store.dispatch(bindGoogle(token));
			} else {
				store.dispatch(getMemberData());
			}
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Member/index.js